'use es6';

import { getProviderServerError, ERROR_ELEMENT_TYPES, getProviderErrorHelpLink, isLinkPlaceholder } from 'InboxConnectUtils/constants/BasicAuthInboxErrors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BasicAuthConnectError({
  errorCode,
  providerType
}) {
  const errorMessage = getProviderServerError(providerType, errorCode, ERROR_ELEMENT_TYPES.body);
  const link = getProviderErrorHelpLink(providerType, errorCode);
  if (link) {
    const options = isLinkPlaceholder(link) ? {
      style: {
        display: 'none'
      }
    } : {
      external: true,
      href: link
    };
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `${errorMessage}_jsx`,
      elements: {
        UILink: Link
      },
      options: options
    });
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: errorMessage
  });
}